import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress, 
  Container,
  Alert,
  Paper,
  Button
} from '@mui/material';
import { Add as AddIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import ActionCard from '../../components/Actions/ActionCard';
import { getActions } from '../../service/Actions/getActions';
import { useNavigate } from 'react-router-dom';
import { getCurrentDateInISOFormat } from '../../service/Util/dateTimeUtil';

// You'll need to configure this based on your environment
const CONFIG = {
  Shortname: 'BHGRE' // or get from your config
};

const primaryColor = CONFIG.Shortname === 'BHGRE' ? '#339933' : '#beb28b';

const UpcomingActions = () => {
  const navigate = useNavigate();

  const [upcomingActions, setUpcomingActions] = useState([]);
  const [isLoadingActions, setIsLoadingActions] = useState(true);
  const [isErrorLoadingActions, setIsErrorLoadingActions] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const fetchUpcomingActions = async (isRefreshAction = false) => {
    if (isRefreshAction) {
      setIsRefreshing(true);
    } else {
      setIsLoadingActions(true);
    }
    setIsErrorLoadingActions(false);

    try {
      const resData = await getActions(15); // Fetch the upcoming actions for next 15 days
      const fetchedActions = resData.data;
      setUpcomingActions([...fetchedActions]);
    } catch (error) {
      setIsErrorLoadingActions(true);
    } finally {
      setIsLoadingActions(false);
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    fetchUpcomingActions();
  }, []);

  const handleRefresh = () => {
    fetchUpcomingActions(true);
  };

  const handleAddAction = () => {
    try {
      navigate('/actions/add');
    } catch (error) {

    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Upcoming Actions
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <LoadingButton
            loading={isRefreshing}
            loadingPosition="start"
            startIcon={<RefreshIcon />}
            variant="outlined"
            onClick={handleRefresh}
          >
            Refresh
          </LoadingButton>
        </Box>
      </Box>

      <Paper sx={{ p: 2, backgroundColor: '#f5f5f5', minHeight: 400 }}>
        {isLoadingActions && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {!isLoadingActions && isErrorLoadingActions && (
          <Alert severity="error">
            Error loading upcoming actions, please try again later.
          </Alert>
        )}

        {!isLoadingActions && !isErrorLoadingActions && upcomingActions.length === 0 && (
          <Alert severity="info">
            There are no upcoming actions.
          </Alert>
        )}

        {!isLoadingActions && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAddAction}
              sx={{
                backgroundColor: primaryColor,
                color: '#FFF',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: primaryColor,
                  filter: 'brightness(0.9)',
                },
              }}
            >
              ADD ACTION
            </Button>
          </Box>
        )}

        {!isLoadingActions && !isErrorLoadingActions && upcomingActions.length > 0 && (
          <Box>
            {upcomingActions.map((item) => (
              <ActionCard 
                key={item.actionID} 
                item={item} 
                fromScreen='UpcomingActionsScreen' 
              />
            ))}
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default UpcomingActions;